import { render, staticRenderFns } from "./CardFrogs.vue?vue&type=template&id=52dbf596&"
import script from "./CardFrogs.vue?vue&type=script&lang=js&"
export * from "./CardFrogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports